import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Col } from 'reactstrap';
import NewCommunicationForm from '../../Forms/NewCommunicationForm';

const NewCommunication = ({ practiceId, refresh }) => {
    const history = useHistory();
    const cancel = () => history.goBack();
    const onSubmit = useCallback(
        (newId) => {
            refresh();
            history.push(`/practices/${practiceId}/communications/${newId}`);
        },
        [practiceId, refresh, history]
    );
    return (
        <Col lg="7" className="sc-glass sc-rounded p-3">
            <NewCommunicationForm
                practiceId={practiceId}
                cancel={cancel}
                cancelAction={onSubmit}
            />
        </Col>
    );
};

export default NewCommunication;
